/**
 * Copyright 2022 Design Barn Inc.
 */

export enum HitCountEvents {
  DOWNLOAD_GIF = 13,
  RENDER_REQUEST = 15,
  DOWNLOAD_STATIC = 32,
  LOGIN = 39,
  DOWNLOAD_LOTTIE_JSON = 0,
  DOWNLOAD_LOTTIE_JSON_PRIVATE = 8,
}
